const isOffline = () => {
  const state = localStorage.getItem('offlineMode') ?? 'false'
  return state === 'true'
}

export default isOffline
